export enum TechStackIconName {
  // languages
  dotNetCore = '.NET Core',
  javascript = 'Javascript',
  typescript = 'Typescript',
  python = 'Python',
  // frontend
  react = 'React',
  nextjs = 'Next.js',
  redux = 'Redux',
  tanstackQuery = 'Tanstasck Query',
  tailwind = 'Tailwind',
  reactNative = 'React Native',
  // backend
  nodejs = 'Node.js',
  nestjs = 'NestJS',
  vite = 'Vite',
  socketIO = 'Socket.io',
  semanticKernel = 'Semantic Kernel',
  langChain = 'LangChain',
  chroma = 'Chroma',
  // databases
  postgreSQL = 'PostgreSQL',
  redis = 'Redis',
  firebase = 'Firebase',
  mongoDB = 'MongoDB',
  azureSQL = 'Azure SQL',
  // tools
  azure = 'Azure',
  orval = 'Orval',
  figma = 'Figma',
  rabbitMQ = 'RabbitMQ',
  azureServiceBus = 'Azure Service Bus',
  langSmith = 'LangSmith',
}

export function getTechStackIconNameByValue(value: string) {
  return Object.values(TechStackIconName).filter((x) => x == value)[0]
}

type TechStackIcon = {
  name: TechStackIconName
  mobileUrl: string
  tabletUrl: string
  desktopUrl: string
}

const techStackIcons: TechStackIcon[] = [
  {
    name: TechStackIconName.azureSQL,
    desktopUrl: '/assets/tech-stack/azuresql-1920w.webp',
    tabletUrl: '/assets/tech-stack/azuresql-1024w.webp',
    mobileUrl: '/assets/tech-stack/azuresql-425w.webp',
  },
  {
    name: TechStackIconName.azureServiceBus,
    desktopUrl: '/assets/tech-stack/azure-service-bus-1920w.webp',
    tabletUrl: '/assets/tech-stack/azure-service-bus-1024w.webp',
    mobileUrl: '/assets/tech-stack/azure-service-bus-425w.webp',
  },
  {
    name: TechStackIconName.dotNetCore,
    desktopUrl: '/assets/tech-stack/dotnetcore-1920w.webp',
    tabletUrl: '/assets/tech-stack/dotnetcore-1024w.webp',
    mobileUrl: '/assets/tech-stack/dotnetcore-425w.webp',
  },
  {
    name: TechStackIconName.figma,
    desktopUrl: '/assets/tech-stack/figma-1920w.webp',
    tabletUrl: '/assets/tech-stack/figma-1024w.webp',
    mobileUrl: '/assets/tech-stack/figma-425w.webp',
  },
  {
    name: TechStackIconName.firebase,
    desktopUrl: '/assets/tech-stack/firebase-1920w.webp',
    tabletUrl: '/assets/tech-stack/firebase-1024w.webp',
    mobileUrl: '/assets/tech-stack/firebase-425w.webp',
  },
  {
    name: TechStackIconName.javascript,
    desktopUrl: '/assets/tech-stack/javascript-1920w.webp',
    tabletUrl: '/assets/tech-stack/javascript-1024w.webp',
    mobileUrl: '/assets/tech-stack/javascript-425w.webp',
  },
  {
    name: TechStackIconName.mongoDB,
    desktopUrl: '/assets/tech-stack/mongodb-1920w.webp',
    tabletUrl: '/assets/tech-stack/mongodb-1024w.webp',
    mobileUrl: '/assets/tech-stack/mongodb-425w.webp',
  },
  {
    name: TechStackIconName.nextjs,
    desktopUrl: '/assets/tech-stack/nextjs-1920w.webp',
    tabletUrl: '/assets/tech-stack/nextjs-1024w.webp',
    mobileUrl: '/assets/tech-stack/nextjs-425w.webp',
  },
  {
    name: TechStackIconName.nodejs,
    desktopUrl: '/assets/tech-stack/nodejs-1920w.webp',
    tabletUrl: '/assets/tech-stack/nodejs-1024w.webp',
    mobileUrl: '/assets/tech-stack/nodejs-425w.webp',
  },
  {
    name: TechStackIconName.orval,
    desktopUrl: '/assets/tech-stack/orval-1920w.webp',
    tabletUrl: '/assets/tech-stack/orval-1024w.webp',
    mobileUrl: '/assets/tech-stack/orval-425w.webp',
  },
  {
    name: TechStackIconName.postgreSQL,
    desktopUrl: '/assets/tech-stack/postgresql-1920w.webp',
    tabletUrl: '/assets/tech-stack/postgresql-1024w.webp',
    mobileUrl: '/assets/tech-stack/postgresql-425w.webp',
  },
  {
    name: TechStackIconName.rabbitMQ,
    desktopUrl: '/assets/tech-stack/rabbitmq-1920w.webp',
    tabletUrl: '/assets/tech-stack/rabbitmq-1024w.webp',
    mobileUrl: '/assets/tech-stack/rabbitmq-425w.webp',
  },
  {
    name: TechStackIconName.react,
    desktopUrl: '/assets/tech-stack/react-1920w.webp',
    tabletUrl: '/assets/tech-stack/react-1024w.webp',
    mobileUrl: '/assets/tech-stack/react-425w.webp',
  },
  {
    name: TechStackIconName.redis,
    desktopUrl: '/assets/tech-stack/redis-1920w.webp',
    tabletUrl: '/assets/tech-stack/redis-1024w.webp',
    mobileUrl: '/assets/tech-stack/redis-425w.webp',
  },
  {
    name: TechStackIconName.redux,
    desktopUrl: '/assets/tech-stack/redux-1920w.webp',
    tabletUrl: '/assets/tech-stack/redux-1024w.webp',
    mobileUrl: '/assets/tech-stack/redux-425w.webp',
  },
  {
    name: TechStackIconName.socketIO,
    desktopUrl: '/assets/tech-stack/socketio-1920w.webp',
    tabletUrl: '/assets/tech-stack/socketio-1024w.webp',
    mobileUrl: '/assets/tech-stack/socketio-425w.webp',
  },
  {
    name: TechStackIconName.tailwind,
    desktopUrl: '/assets/tech-stack/tailwind-1920w.webp',
    tabletUrl: '/assets/tech-stack/tailwind-1024w.webp',
    mobileUrl: '/assets/tech-stack/tailwind-425w.webp',
  },
  {
    name: TechStackIconName.tanstackQuery,
    desktopUrl: '/assets/tech-stack/tanstack-query-1920w.webp',
    tabletUrl: '/assets/tech-stack/tanstack-query-1024w.webp',
    mobileUrl: '/assets/tech-stack/tanstack-query-425w.webp',
  },
  {
    name: TechStackIconName.typescript,
    desktopUrl: '/assets/tech-stack/typescript-1920w.webp',
    tabletUrl: '/assets/tech-stack/typescript-1024w.webp',
    mobileUrl: '/assets/tech-stack/typescript-425w.webp',
  },
  {
    name: TechStackIconName.vite,
    desktopUrl: '/assets/tech-stack/vite-1920w.webp',
    tabletUrl: '/assets/tech-stack/vite-1024w.webp',
    mobileUrl: '/assets/tech-stack/vite-425w.webp',
  },
  {
    name: TechStackIconName.semanticKernel,
    desktopUrl: '/assets/tech-stack/semantic-kernel-1920w.webp',
    tabletUrl: '/assets/tech-stack/semantic-kernel-1024w.webp',
    mobileUrl: '/assets/tech-stack/semantic-kernel-425w.webp',
  },
  {
    name: TechStackIconName.langChain,
    desktopUrl: '/assets/tech-stack/langchain-1920w.webp',
    tabletUrl: '/assets/tech-stack/langchain-1024w.webp',
    mobileUrl: '/assets/tech-stack/langchain-425w.webp',
  },
  {
    name: TechStackIconName.python,
    desktopUrl: '/assets/tech-stack/python-1920w.webp',
    tabletUrl: '/assets/tech-stack/python-1024w.webp',
    mobileUrl: '/assets/tech-stack/python-425w.webp',
  },
  {
    name: TechStackIconName.langSmith,
    desktopUrl: '/assets/tech-stack/langsmith-1920w.webp',
    tabletUrl: '/assets/tech-stack/langsmith-1024w.webp',
    mobileUrl: '/assets/tech-stack/langsmith-425w.webp',
  },
  {
    name: TechStackIconName.chroma,
    desktopUrl: '/assets/tech-stack/chroma-1920w.webp',
    tabletUrl: '/assets/tech-stack/chroma-1024w.webp',
    mobileUrl: '/assets/tech-stack/chroma-425w.webp',
  },
  {
    name: TechStackIconName.nestjs,
    desktopUrl: '/assets/tech-stack/nestjs-1920w.png',
    tabletUrl: '/assets/tech-stack/nestjs-1024w.png',
    mobileUrl: '/assets/tech-stack/nestjs-425w.png',
  },
  {
    name: TechStackIconName.reactNative,
    desktopUrl: '/assets/tech-stack/react-native-1920w.png',
    tabletUrl: '/assets/tech-stack/react-native-1024w.png',
    mobileUrl: '/assets/tech-stack/react-native-425w.png',
  },
  {
    name: TechStackIconName.azure,
    desktopUrl: '/assets/tech-stack/azure-1920w.png',
    tabletUrl: '/assets/tech-stack/azure-1024w.png',
    mobileUrl: '/assets/tech-stack/azure-425w.png',
  },
]

export default techStackIcons
